import { declareWebpackPublicPath } from '@commercial-web-client-config/runtime-config-vue-app';
declareWebpackPublicPath();
